module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.471fc24f.eot";